
import starfun from './../../assets/images/starfun.jpg'
import sudokufun from './../../assets/images/sudokufun.jpg'
import knifefun from './../../assets/images/knifefun.jpg'
import wwfstack from './../../assets/images/wwfstack.jpg'
import wwfconnect from './../../assets/images/wwfconnect.jpg'

const GameDatas = [
  {
      name: "Words World Fun: Stacks",
      image: wwfstack,
      description: null,
      playstoreUrl: "https://play.google.com/store/apps/details?id=dev.adzkiya.puzzle.wordgames.wordstack",
      appstoreUrl: null
  },
  
  {
      name: "Words World Fun: Connect",
      image: wwfconnect,
      description: null,
      playstoreUrl: "https://play.google.com/store/apps/details?id=dev.adzkiya.games.wordconnect.worldjourney",
      appstoreUrl: null
  },
  
  {
      name: "Knife Fun - Ultimate Knife Hit",
      image: knifefun,
      description: null,
      playstoreUrl: "https://play.google.com/store/apps/details?id=dev.adzkiya.games.knifehit.legends",
      appstoreUrl: null
  },
  
  {
      name: "Sudoku Fun",
      image: sudokufun,
      description: null,
      playstoreUrl: "https://play.google.com/store/apps/details?id=com.yasminadzkiya.sudoku",
      appstoreUrl: null
  },
  
  {
      name: "StarFun - Lines Connect",
      image: starfun,
      description: null,
      playstoreUrl: "https://play.google.com/store/apps/details?id=dev.adzkiya.games.puzzle.dotconnect.starlink",
      appstoreUrl: null
  }
  ];

  export default GameDatas